export const allowedSizes = ["600x600", "500x500", "400x300", "400x400", "350x170", "330x330", "300x300", "200x200", "160x160", "100x70"];
type AllowedSize = (typeof allowedSizes)[number];

export class ImageResizer {
  static getProductImageUrl(path: string, size: AllowedSize) {
    const [brand, image] = path.split("/");
    return import.meta.env.PUBLIC_RESIZED_ASSETS_HOST + "/" + size + "/" + brand + "::" + image;
  }
}
